import React from 'react';
import { ArrowRightIcon } from 'lucide-react';
type ButtonProps = {
  children: React.ReactNode;
  className?: string;
  variant?: 'primary' | 'secondary' | 'outline';
  size?: 'sm' | 'lg';
  arrow?: boolean;
  href?: string;
  target?: '_blank';
  rel?: string;
  onClick?: () => void;
  ariaLabel?: string;
};
export function Button({
  children,
  className = '',
  variant = 'primary',
  size = 'lg',
  arrow = false,
  href,
  target,
  rel,
  onClick,
  ariaLabel
}: ButtonProps) {
  const styles = {
    primary: 'bg-gold text-navy-950 shadow-lg shadow-gold/20 transition-[background-color,transform] hover:bg-gold-light active:scale-[0.98]',
    secondary: 'border border-line bg-navy-900 text-white transition-[background-color,transform] hover:bg-navy-800 active:scale-[0.98]',
    outline: 'border border-fiber bg-transparent text-fiber transition-colors hover:bg-navy-900'
  };
  const sizes = {
    sm: 'px-4 py-2.5 text-sm',
    lg: 'px-6 py-3.5 text-base sm:px-8 sm:py-4'
  };
  const classes = `inline-flex items-center justify-center gap-2 whitespace-nowrap rounded-lg font-semibold duration-150 ease-out focus:outline-none focus-visible:ring-2 focus-visible:ring-fiber focus-visible:ring-offset-2 focus-visible:ring-offset-navy-950 ${styles[variant]} ${sizes[size]} ${className}`;
  if (href) {
    return <a href={href} target={target} rel={rel} onClick={onClick} className={classes} aria-label={ariaLabel} data-id="element-189" data-mp="on0zxt5jow2g">
        {children}
        {arrow && <ArrowRightIcon className="h-5 w-5" aria-hidden="true" data-id="element-190" data-mp="12l8slovjtb7t" />}
      </a>;
  }
  return <button type="button" onClick={onClick} className={classes} aria-label={ariaLabel} data-id="element-191" data-mp="xo8mxf2m2ah8">
      {children}
      {arrow && <ArrowRightIcon className="h-5 w-5" aria-hidden="true" data-id="element-192" data-mp="1cf95we0zhmrm" />}
    </button>;
}